// 环境配置文件
const config = {
  development: {
    // 开发环境配置
    llmApiBaseUrl: 'http://localhost:8070',
    apiBaseUrl: '/api/v1'
  },
  production: {
    // 生产环境配置
    llmApiBaseUrl: '', // 使用根路径，通过nginx代理（已去掉/llm前缀）
    apiBaseUrl: '/api/v1'
  }
};

// 判断当前环境
const getEnvironment = () => {
  // 可以通过多种方式判断环境
  
  // 方式1: 检查hostname
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'development';
  }
  
  // 方式2: 检查是否有端口号（开发环境通常有端口号）
  if (window.location.port && window.location.port !== '80' && window.location.port !== '443') {
    return 'development';
  }
  
  // 方式3: 检查环境变量（如果有的话）
  if (process.env.NODE_ENV === 'development') {
    return 'development';
  }
  
  // 默认为生产环境
  return 'production';
};

// 获取当前环境配置
const getCurrentConfig = () => {
  const env = getEnvironment();
  return config[env];
};

// 导出配置
export const currentConfig = getCurrentConfig();
export const environment = getEnvironment();

// 导出常用的URL构建函数
export const getLlmApiUrl = (endpoint) => {
  const baseUrl = currentConfig.llmApiBaseUrl;
  return `${baseUrl}${endpoint}`;
};

export const getApiUrl = (endpoint) => {
  const baseUrl = currentConfig.apiBaseUrl;
  return `${baseUrl}${endpoint}`;
};

export default currentConfig;
